import { BetaText, GradientContainer } from "./BetaLabel.styles";

export type BetaLabelProps = {
  size?: 'small' | 'medium'
  colors?: string[]
  locations?: number[]
  angle?: number
}

function BetaLabel({
  size = 'medium',
  colors = ['#3C53D7', '#1A1B6E'],
  locations = [0.0001, 0.9],
  angle = 117.03
}: BetaLabelProps) {
  // Create CSS gradient string
  const gradientBackground = `linear-gradient(${angle}deg, ${colors[0]} ${locations[0] * 100}%, ${colors[1]} ${locations[1] * 100}%)`;

  return (
    <GradientContainer size={size} $gradientBackground={gradientBackground}>
      <BetaText size={size}>Beta</BetaText>
    </GradientContainer>
  );
}

export default BetaLabel;
